module.exports = __webpack_public_path__ + "static/media/Confluence.fda15488.png";